<form class="login-form" [formGroup]="loginFormGrp">
  @if (errorMessage) {
    <div class="error-container">
      {{errorMessage}}
    </div>
  }
  <div class="row">
    <div class="required col-sm-12 form-group">
      <label for="username">
        <span>{{ "login.user_name" | translate }}</span>
      </label>
      <input id="username"  autocomplete="off"  type="email" matInput formControlName="username" [errorStateMatcher]="matcher" placeholder="">
      @if (loginFormGrp.get('username')?.hasError('email') && !loginFormGrp.get('username')?.hasError('required')) {
        <mat-error>
          {{'login.please_enter_valid_email' | translate}}
        </mat-error>
      }
    </div>
  </div>
  <div class="row">
    <div class="required col-sm-12 form-group">
      <label for="password">
        <span>{{ "login.password" | translate }}</span>
      </label>
      <input #password id="password"  autocomplete="off"  type="password" matInput formControlName="password" [errorStateMatcher]="matcher">
      @if (loginFormGrp.get('password')?.hasError('required')) {
        <mat-error>
          <span [innerHtml]="'login.password_is_required' | translate"></span>
        </mat-error>
      }
    </div>
  </div>
  <div class="row col-sm-12">
    <div>
      <input type="checkbox" (click)="showPassword(password)">
    </div>
    <div class="ml-2 mt-2"> {{'common.show_password' | translate}} </div>
  </div>
  <div class="flex-column-center">
    <uw-button [loading]="buttonLoading"  (buttonClick)="login()"  btnLabel="{{'login.log_in' | translate}}"></uw-button>
    <button [title]="'login.forgotPassword' | translate" mat-button [uwRouterLink]="['/donor', campaignGuid, {outlets: {sidebar: ['forgotpassword']}}]">{{ "login.forgotPassword" | translate }}?</button>
  </div>
</form>

<uw-language-selector></uw-language-selector>
